import { useCallback, useEffect, useRef, useState } from 'react'
import { Empty, message, Spin } from 'antd'
import { RedoOutlined } from '@ant-design/icons'
import { AiCategoryRecommendItem } from '@/api/MaterialApi'
import { selectNodeParam } from '@/components/TreeAll'
import {
  fetchAiCategoryRecommendations,
  toCategorySelectNodeParam,
} from './aiCategoryRecommendUtils'
import Style from './aiCategoryRecommend.module.scss'

interface Props {
  materialName: string
  description?: string
  visible: boolean
  disabled: boolean
  onSelectCategory: (category: selectNodeParam) => void
}

const AiCategoryRecommend = ({
  materialName,
  description,
  visible,
  disabled,
  onSelectCategory,
}: Props) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [recommendations, setRecommendations] = useState<
    AiCategoryRecommendItem[]
  >([])
  const requestIdRef = useRef(0)

  const fetchRecommendations = useCallback(async (showEmptyWarning = false) => {
    const requestId = ++requestIdRef.current
    if (!materialName.trim()) {
      if (showEmptyWarning) message.warning('请先填写物料名称')
      setRecommendations([])
      setError(false)
      setLoading(false)
      return
    }
    setLoading(true)
    setError(false)
    try {
      const data = await fetchAiCategoryRecommendations(
        materialName,
        description,
      )
      if (requestId === requestIdRef.current) setRecommendations(data)
    } catch {
      if (requestId === requestIdRef.current) setError(true)
    } finally {
      if (requestId === requestIdRef.current) setLoading(false)
    }
  }, [description, materialName])

  const getConfidenceLevel = (confidence: number) => {
    if (confidence >= 80) return 'high'
    if (confidence >= 60) return 'medium'
    return 'low'
  }

  useEffect(() => {
    if (visible) {
      fetchRecommendations()
    } else {
      requestIdRef.current += 1
      setRecommendations([])
      setError(false)
      setLoading(false)
    }
    // 仅在弹框打开时查询，物料名称变化不会自动发起新请求。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  return (
    <div className={Style.panel}>
      <div className={Style.header}>
        <span className={Style.title}>
          <span className={Style.aiTag}>AI</span>
          推荐类目
        </span>
        {!loading && (
          <a
            className={Style.retryButton}
            onClick={() => fetchRecommendations(true)}
          >
            <RedoOutlined /> 重试
          </a>
        )}
      </div>
      {loading ? (
        <div className={Style.status}>
          <Spin />
          <span>AI 正在分析推荐类目...</span>
        </div>
      ) : error ? (
        <div className={Style.status}>AI审核异常</div>
      ) : recommendations.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无推荐类目" />
      ) : (
        <div className={Style.list}>
          {recommendations.map((item, index) => {
            const confidenceLevel = getConfidenceLevel(item.confidence)
            return (
              <button
                type="button"
                className={Style.item}
                key={`${item.categoryId}-${index}`}
                disabled={disabled}
                onClick={() =>
                  onSelectCategory(toCategorySelectNodeParam(item))
                }
              >
                <span
                  className={`${Style.rank} ${Style[`rank${index + 1}`] || ''}`}
                >
                  {index + 1}
                </span>
                <span className={Style.content}>
                  <span className={Style.name}>{item.categoryName}</span>
                  <span className={Style.code}>编码：{item.categoryCode}</span>
                  <span className={Style.confidence}>
                    <span className={Style.confidenceTrack}>
                      <span
                        className={`${Style.confidenceFill} ${Style[confidenceLevel]}`}
                        style={{
                          width: `${Math.min(100, Math.max(0, item.confidence))}%`,
                        }}
                      />
                    </span>
                    <span className={Style.confidenceText}>
                      {item.confidence}%
                    </span>
                  </span>
                  {item.reason ? (
                    <span className={Style.reason}>{item.reason}</span>
                  ) : null}
                </span>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default AiCategoryRecommend
import { useCallback, useEffect, useRef, useState } from 'react'
import { Empty, message, Spin } from 'antd'
import { RedoOutlined } from '@ant-design/icons'
import { AiCategoryRecommendItem } from '@/api/MaterialApi'
import { selectNodeParam } from '@/components/TreeAll'
import {
  fetchAiCategoryRecommendations,
  toCategorySelectNodeParam,
} from './aiCategoryRecommendUtils'
import Style from './aiCategoryRecommend.module.scss'

interface Props {
  materialName: string
  description?: string
  visible: boolean
  disabled: boolean
  onSelectCategory: (category: selectNodeParam) => void
}

const AiCategoryRecommend = ({
  materialName,
  description,
  visible,
  disabled,
  onSelectCategory,
}: Props) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [recommendations, setRecommendations] = useState<
    AiCategoryRecommendItem[]
  >([])
  const requestIdRef = useRef(0)

  const fetchRecommendations = useCallback(async (showEmptyWarning = false) => {
    const requestId = ++requestIdRef.current
    if (!materialName.trim()) {
      if (showEmptyWarning) message.warning('请先填写物料名称')
      setRecommendations([])
      setError(false)
      setLoading(false)
      return
    }
    setLoading(true)
    setError(false)
    try {
      const data = await fetchAiCategoryRecommendations(
        materialName,
        description,
      )
      if (requestId === requestIdRef.current) setRecommendations(data)
    } catch {
      if (requestId === requestIdRef.current) setError(true)
    } finally {
      if (requestId === requestIdRef.current) setLoading(false)
    }
  }, [description, materialName])

  const getConfidenceLevel = (confidence: number) => {
    if (confidence >= 80) return 'high'
    if (confidence >= 60) return 'medium'
    return 'low'
  }

  useEffect(() => {
    if (visible) {
      fetchRecommendations()
    } else {
      requestIdRef.current += 1
      setRecommendations([])
      setError(false)
      setLoading(false)
    }
    // 仅在弹框打开时查询，物料名称变化不会自动发起新请求。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  return (
    <div className={Style.panel}>
      <div className={Style.header}>
        <span className={Style.title}>
          <span className={Style.aiTag}>AI</span>
          推荐类目
        </span>
        {!loading && (
          <a
            className={Style.retryButton}
            onClick={() => fetchRecommendations(true)}
          >
            <RedoOutlined /> 重试
          </a>
        )}
      </div>
      {loading ? (
        <div className={Style.status}>
          <Spin />
          <span>AI 正在分析推荐类目...</span>
        </div>
      ) : error ? (
        <div className={Style.status}>AI审核异常</div>
      ) : recommendations.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无推荐类目" />
      ) : (
        <div className={Style.list}>
          {recommendations.map((item, index) => {
            const confidenceLevel = getConfidenceLevel(item.confidence)
            return (
              <button
                type="button"
                className={Style.item}
                key={`${item.categoryId}-${index}`}
                disabled={disabled}
                onClick={() =>
                  onSelectCategory(toCategorySelectNodeParam(item))
                }
              >
                <span
                  className={`${Style.rank} ${Style[`rank${index + 1}`] || ''}`}
                >
                  {index + 1}
                </span>
                <span className={Style.content}>
                  <span className={Style.name}>{item.categoryName}</span>
                  <span className={Style.code}>编码：{item.categoryCode}</span>
                  <span className={Style.confidence}>
                    <span className={Style.confidenceTrack}>
                      <span
                        className={`${Style.confidenceFill} ${Style[confidenceLevel]}`}
                        style={{
                          width: `${Math.min(100, Math.max(0, item.confidence))}%`,
                        }}
                      />
                    </span>
                    <span className={Style.confidenceText}>
                      {item.confidence}%
                    </span>
                  </span>
                  {item.reason ? (
                    <span className={Style.reason}>{item.reason}</span>
                  ) : null}
                </span>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default AiCategoryRecommend
